import Counter from "./features/counter/Counter";
import Title from "./components/Title";
import Footer from "./components/Footer";

function App() {
  return (
    <div>
      <Title />
      <Counter />
      <Footer />
    </div>
  );
}

export default App;
